import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "row g-3 align-items-end" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Liste des transactions par client")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Type Opération", -1)),
            _createVNode(_component_Multiselect, {
              searchable: true,
              options: _ctx.lestypes,
              modelValue: _ctx._type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx._type) = $event)),
              placeholder: "Choisir"
            }, null, 8, ["options", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Créance", -1)),
            _createVNode(_component_Multiselect, {
              options: _ctx.creanceOptions,
              searchable: true,
              modelValue: _ctx._creance,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx._creance) = $event)),
              placeholder: "Sélectionner la créance"
            }, null, 8, ["options", "modelValue"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " DATE "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Reference "),
              _createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-black-emphasis" }, " LIBELLE DE L'OPERATION "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " DEBIT "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " CREDIT "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " SOLDE "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " SOLDE AVEC Plafond ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (transaction, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.format_Date(transaction?.dateTransaction)), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(transaction?.reference), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(transaction?.motif), 1),
                _createElementVNode("td", _hoisted_14, [
                  (transaction?.typeOperation == 'DEBIT')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.separateur(transaction?.montant)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_16, [
                  (transaction?.typeOperation == 'CREDIT')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.separateur(transaction?.montant)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.separateur(transaction?.solde )), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.separateur(transaction?.solde )), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.separateur(transaction?.solde )), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.separateur(transaction?.soldeSansPlafond )), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}